import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const AboutApproval = () => (
  <>
    <Helmet>
      <title>10-Minute Loan Approval — Fastest Salary Loans | Salary Uncle</title>
      <meta name="description" content="Get instant loan approval in under 10 minutes with AI-powered evaluation. Salary Uncle delivers India's fastest salary loans." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/about-us" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to About
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
          </svg>
        </div>
        <span className="fd-tag">LIGHTNING SPEED</span>
        <h1>10-Minute Approval</h1>
        <p>Industry-leading speed — AI-powered evaluation delivers loan decisions in under 10 minutes, with disbursal in just 30 minutes.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "Real-Time AI Evaluation", desc: "Our AI engine evaluates your salary, credit, and employment profile instantly — no human delays." },
            { title: "Instant OCR Verification", desc: "Auto-extracts data from Aadhaar, PAN & salary slips in seconds. No manual data entry." },
            { title: "30-Minute Disbursement", desc: "Once approved, funds hit your bank account within 30 minutes through IMPS/NEFT." },
            { title: "Live Status Tracking", desc: "Track your application in real time via SMS, email, and your personal dashboard." },
            { title: "Pre-Approved Offers", desc: "Returning customers see pre-approved offers — apply with just one tap." },
            { title: "24/7 Application", desc: "Apply anytime — weekends, holidays, midnight — our system runs round the clock." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>How 10-Min Approval Works</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Apply online with mobile number and basic details (1 min)." },
              { step: "2", text: "Upload Aadhaar, PAN & salary slip — auto-verified by OCR (3 min)." },
              { step: "3", text: "AI evaluates eligibility in real time (2 min)." },
              { step: "4", text: "Receive loan offer instantly — accept terms (2 min)." },
              { step: "5", text: "eKYC + e-Sign completed — funds disbursed in 30 minutes." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default AboutApproval;
